import { render, staticRenderFns } from "./TheclinicNavbarVertical.vue?vue&type=template&id=55627502&"
import script from "./TheclinicNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheclinicNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports